import toastManager from "../toastManager";

export const handleMenuRedirectPairs = ({
  hasDataChanged,
  comparisonItems,
  deleteEntry,
  entrySavedStatus,
  handlePageLeave,
}) => {
  const dataChanged = hasDataChanged();

  let emptyPairs = false;
  let halfEmptyPairs = false;
  let fullPairs = false;

  for (const { fileOne, fileTwo } of comparisonItems) {
    const fileOneEmpty = fileOne.length === 0;
    const fileTwoEmpty = fileTwo.length === 0;

    if (fileOneEmpty && fileTwoEmpty) {
      emptyPairs = true;
    } else if (!fileOneEmpty && !fileTwoEmpty) {
      fullPairs = true;
    } else {
      halfEmptyPairs = true;
    }
  }

  if (emptyPairs && !halfEmptyPairs && !fullPairs && !dataChanged) {
    deleteEntry();
  } else if (!entrySavedStatus && dataChanged && fullPairs) {
    // Entry contains full pairs, is changed, and unsaved. Prompt to try and save
    toastManager(
      "warning",
      "Save Warning",
      "Entry has unsaved changes. Save entry"
    );
  } else if (!entrySavedStatus && halfEmptyPairs) {
    // Entry contains some empty pairs / half pairs, and is unsaved. Prompt to try and save
    toastManager(
      "warning",
      "Warning",
      "Entry has unsaved changes and is missing images. Add images to pairs, or remove empty pairs and save entry."
    );
  } else if (!dataChanged || entrySavedStatus) {
    // Entry is either unchanged or entry is saved. Redirect to menu
    handlePageLeave();
  }
};
